var map = {
	"./baidu.svg": 9034,
	"./bilibili.svg": 4717,
	"./bing.svg": 8371,
	"./gitee.svg": 2482,
	"./github.svg": 3385,
	"./google.svg": 474,
	"./mogu.svg": 5424,
	"./sjx.svg": 9638,
	"./sougou.svg": 7571,
	"./stackoverflow.svg": 5487,
	"./toutiao.svg": 2873,
	"./zhihu.svg": 7496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;